import { api } from "./api";

/** 调用后端百度翻译代理。to: "en"=中译英, "zh"=英译中 */
export async function translate(q: string, to: "en" | "zh"): Promise<string> {
  const from = to === "en" ? "zh" : "en";
  const res = await api.post<{ text: string }>("/api/admin/translate", { q, from, to });
  return res.text;
}
